import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListGoods from './listGoods';
import Filters from './filters';
import Footer from './footer';
import { withTranslation } from 'react-i18next';
import FilterIcon from '../images/filters_icon.svg';
import { connect } from 'react-redux';
import { clearSearchData, receivingList } from '../actions/list';
import CategoriesPanel from './sub/CategoriesPanel';
import i18n from 'i18next';
import { Helmet } from 'react-helmet';
/**
 * Just a wrapper under list items
 *
 */
class PrList extends Component {
  /**
   *
   * @type {{isShowLoader: *, categoryData: {number, private, static, extends, public, protected, string, bool, constructor, interface, any}, list: string | f.elements.object | Object | CKEDITOR.tools.object | {findKey, merge} | number, orderingData: {number, private, static, extends, public, protected, string, bool, constructor, interface, any}}}
   */
  static propTypes = {
    list: PropTypes.object,
    isShowLoader: PropTypes.bool,
    isShowLoaderMenu: PropTypes.bool,
    category: PropTypes.string,
    order: PropTypes.string,
    limit: PropTypes.string,
    offset: PropTypes.string,
    countCart: PropTypes.number,
    countWish: PropTypes.number,
    countCompare: PropTypes.number,
    joomlaMenu: PropTypes.object,
    location: PropTypes.string,
    categoriesPanel: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = { filterData: false };
  }

  componentWillUnmount() {
    this.props.clearSearch();
  }

  /**
   * Renders menu
   *
   *                 <Menu categoryData={this.props.categoryData} />
   *                 <Ordering orderingData={this.props.orderingData} />
   *
   *
   * @returns {*}
   */
  render() {
    const { t } = this.props;
    const isFilterShow =
      this.props.dataFilters.dataFilters !== undefined &&
      Object.keys(this.props.dataFilters.dataFilters).length > 0
        ? true
        : false;
    const isCategoriesPanel =
      this.props.categoriesPanel && this.props.location.search ? true : false;
    let currentCategoryName = '';
    if (
      this.props.categoriesPanel &&
      this.props.categoriesPanel.length > 0 &&
      this.props.categoriesPanel[this.props.categoriesPanel.length - 1].items &&
      this.props.categoriesPanel[this.props.categoriesPanel.length - 1].items
        .length > 0 &&
      this.props.categoriesPanel[this.props.categoriesPanel.length - 1].items[
        this.props.categoriesPanel[this.props.categoriesPanel.length - 1].items
          .length - 1
      ]
    ) {
      currentCategoryName =
        this.props.categoriesPanel[this.props.categoriesPanel.length - 1].items[
          this.props.categoriesPanel[this.props.categoriesPanel.length - 1]
            .items.length - 1
        ]['name' + i18n.language[0].toUpperCase() + i18n.language.slice(1)];
    }

    return (
      <div key={this.props.match.params.cat}>
        <header>
          <Helmet>
            <title>{currentCategoryName}</title>
          </Helmet>
        </header>
        <div className='main-container uk-container  uk-flex uk-flex-wrap uk-flex-top'>
          <div className='uk-width-1-1 uk-margin-small-top uk-hidden@m'>
            <button
              className='uk-button uk-button-default uk-text-left uk-width-1-1'
              type='button'
              uk-toggle='target: #offcanvas-filters'
            >
              {' '}
              <img
                className='uk-margin-small-right'
                src={FilterIcon}
                uk-svg=''
              />
              {t('shop.filters')}
            </button>

            <div id='offcanvas-filters' uk-offcanvas=' overlay: true'>
              <div className='offcanvas-filter-bar uk-offcanvas-bar'>
                {isCategoriesPanel && (
                  <CategoriesPanel
                    categoriesPanel={this.props.categoriesPanel}
                    location={this.props.location}
                  />
                )}
                {this.props.match.params.cat ? (
                  <Filters
                    filtersUrl={this.props.location.search}
                    location={this.props.location}
                    category={this.props.match.params.cat}
                    isRequest={true}
                    history={this.props.history}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          {
            <>
              <div
                className={`filter uk-width-1-3@m uk-width-1-5@l uk-width-1-1 ${
                  isFilterShow || isCategoriesPanel
                    ? 'uk-visible@m'
                    : 'uk-hidden'
                }`}
              >
                {isCategoriesPanel && (
                  <CategoriesPanel
                    categoriesPanel={this.props.categoriesPanel}
                    location={this.props.location}
                  />
                )}
                {isFilterShow && this.props.match.params.cat ? (
                  <Filters
                    filtersUrl={this.props.location.search}
                    location={this.props.location}
                    category={this.props.match.params.cat}
                    isRequest={false}
                    history={this.props.history}
                  />
                ) : (
                  ''
                )}
              </div>
            </>
          }

          <div
            className={`products-view ${
              isFilterShow || isCategoriesPanel
                ? 'uk-width-2-3@m uk-width-4-5@l'
                : ''
            }  uk-width-1-1 uk-position-relative`}
          >
            <ListGoods
              history={this.props.history}
              categoryData={this.props.match.params.cat}
              filtersUrl={this.props.location.search}
            />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const ProductsList = withTranslation('translations')(PrList);
const mapStateToProps = (store) => {
  const { dataFilters } = store.goods;
  console.log('list gooooods ');
  return {
    dataFilters,
    categoriesPanel: store.goods.listGoods.categoriesProduct,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearSearch: () => {
      //dispatch(clearAllStates());
      dispatch(clearSearchData());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsList);
